export default (actionLabel, callback) => {
  if (!window.isRecaptchaEnabled) {
    return callback();
  }

  if (!grecaptcha) {
    throw Error("Google ReCAPTCHA v3 isn't initialized.");
  }

  const key = document
    .querySelector("meta[name='grecaptcha-key']")
    .getAttribute("content");

  grecaptcha.ready(() => {
    grecaptcha.execute(key, {action: actionLabel})
      .then((token) => {
        if (!token) {
          throw Error("Google ReCAPTCHA v3 is enabled but no token has been provided.");
        }

        callback(token);
      });
  });
}
